import { render, staticRenderFns } from "./uploadHealthCode.vue?vue&type=template&id=de87c9fc&scoped=true&"
import script from "./uploadHealthCode.vue?vue&type=script&lang=js&"
export * from "./uploadHealthCode.vue?vue&type=script&lang=js&"
import style0 from "./uploadHealthCode.vue?vue&type=style&index=0&id=de87c9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de87c9fc",
  null
  
)

export default component.exports